import React from 'react'

const Dashboard6 = () => {
  return (
    <h1>Dashboard6</h1>
  )
}

export default Dashboard6